module.exports = __webpack_public_path__ + "assets/img/icon_progress.b5892487.png";